import { Button } from '@mui/material';
import { LanguageSwitcher } from 'components/language-switcher';
import { InfoCard } from 'components/notification-cards';
import { Text } from 'components/Text';
import { IMAGES } from 'config/images';
import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import { CV_BUILDER_STEPS, ZENJOB_LOGO_ALT_TEXT } from '../constants';
import {
  BodyContainer,
  ButtonContainer,
  HeaderContainer,
  LogoBox,
  RootBox,
  TitleContainer
} from './styledComponents';

export const Intro = () => (
  <RootBox>
    <HeaderContainer sx={{ p: 0 }}>
      <LogoBox>
        <img alt={ZENJOB_LOGO_ALT_TEXT} src={IMAGES.proLogoPurple} />
      </LogoBox>
      <LanguageSwitcher />
    </HeaderContainer>
    <TitleContainer sx={{ pt: 5, pb: 2 }}>
      <Text variant="h2">{getTrans('cvBuilderPage.intro.heading')}</Text>
    </TitleContainer>
    <BodyContainer>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.body1')}
      </Text>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.body2.part1')}&nbsp;
        <b>{getTrans('cvBuilderPage.intro.body2.part2')}</b>&nbsp;
        {getTrans('cvBuilderPage.intro.body2.part3')}
      </Text>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.body3')}
      </Text>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.body4')}
      </Text>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.body5')}
      </Text>
      <Text variant="body2" mt={1}>
        <b>{getTrans('cvBuilderPage.intro.body6.part1')}</b>&nbsp;
        {getTrans('cvBuilderPage.intro.body6.part2')}
      </Text>
    </BodyContainer>
    <InfoCard>
      <Text variant="body2">
        <b>{getTrans('cvBuilderPage.intro.infoCard.body1')}</b>
      </Text>
      <Text variant="body2" mt={1}>
        {getTrans('cvBuilderPage.intro.infoCard.body2.part1')}&nbsp;
        <b>{getTrans('cvBuilderPage.intro.infoCard.body2.part2')}</b>&nbsp;
        {getTrans('cvBuilderPage.intro.infoCard.body2.part3')}&nbsp;
        <b>{getTrans('cvBuilderPage.intro.infoCard.body2.part4')}</b>&nbsp;
        {getTrans('cvBuilderPage.intro.infoCard.body2.part5')}&nbsp;
      </Text>
    </InfoCard>
    <ButtonContainer>
      <Button
        color="primary"
        variant="contained"
        href={`${PATHS.cvBuilder}?step=${CV_BUILDER_STEPS.OVERVIEW}`}
        sx={{ minWidth: 252 }}
        data-testid="cv-builder-intro-button"
      >
        {getTrans('cvBuilderPage.intro.button')}
      </Button>
    </ButtonContainer>
  </RootBox>
);
